export const notifications = {
  notifications: {
    prompt: {
      title: "接收重要通知",
      description: "启用通知以接收有关特别促销、游戏结果和最新消息的提醒。",
      error: "启用通知时发生错误",
      later: "稍后",
      enable: "启用通知",
      activating: "激活中...",
    },
  },
};
